module.exports = __webpack_public_path__ + "files/9639ebb67c3d10dba585a3e248ebf9bf.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-60x60.png
// module id = 1244
// module chunks = 76